function parseRSS(url, callback, selector, items_count, max_chars) {

  $.ajax({
    url: document.location.protocol + '//ajax.googleapis.com/ajax/services/feed/load?v=1.0&num=10&callback=?&q=' + encodeURIComponent(url),
    dataType: 'json',
    success: function(data) {
      callback(data.responseData.feed, selector, items_count, max_chars);
    }
  });
}

function populate_news(rss, selector, items_count, max_chars)
{
	var count = 0;
	var box = $(selector);
	var item_template = box.find('.item').clone();
	box.find('.item').remove();
	
	$.each(rss.entries, function(index, element){
		
		var new_item = item_template.clone();
		
		if(element.contentSnippet.length+3 > max_chars){
			element.contentSnippet = element.contentSnippet.substr(0, max_chars)+'...';
		}
		
		var today = new Date();
		var d1 = new Date(element.publishedDate);
		var dd = d1.getDate(); if(dd < 10){ dd = "0"+dd; }
		var mm = d1.getMonth()+1; if(mm < 10){ mm = "0"+mm; }
		
		new_item.find('.date').text("("+ mm + "/" + dd + "/" + d1.getUTCFullYear() + ")" );
		new_item.find('.title').text( element.title );
		new_item.find('a.link').attr('href', element.link );
		new_item.find('.image').parent().attr('src', element.link );
		new_item.find('.text').text( element.contentSnippet );
		
		box.append(new_item.fadeIn(200));
		
		count++;
		if(count >= items_count) return false;
	});
	
	box.trigger('new_content');
	
}

// structure .js_news_box .item
// .news_item_date, .title, a.link, .image, .text
//parseRSS('http://blog.elitehelse.no', populate_news, '.js_news_box', 3, 80);